import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../external-library/axios-interceptor/Interceptor";
import { homeServerUrl } from "../../environment/Environment";

export const fetchCountryDetails = createAsyncThunk(
    'selectedcountry/fetchCountryDetails',
    async (countryName, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `${homeServerUrl}/countries/${countryName}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 
                error.message || 
                'Errore nel caricamento dei dettagli del country'
            );
        }
    }
);

const initialState = {
    selectedCountry: "",
    countryDetails: null,
    loading: false,
    error: null,
};

const selectedCountryChange = createSlice({
    name: "selectedcountry",
    initialState,
    reducers: {
        selectedCountryChangingAction: (state, action) => {
            state.selectedCountry = action.payload;
            state.countryDetails = null;
            state.error = null;
        },
        resetSelectedCountry: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountryDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountryDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.countryDetails = action.payload;
            })
            .addCase(fetchCountryDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { selectedCountryChangingAction, resetSelectedCountry } = selectedCountryChange.actions;
export default selectedCountryChange.reducer;
